import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

const ADVANCE_PAYMENT_ENABLED_PREFERENCE_KEY = 'advancePaymentEnabledPreference';

type UseAdvancePaymentEnabledPreferenceReturnFn = {
   advancePaymentEnabledPreference: boolean | undefined;
   handleSetAdvancePaymentEnabledPreference: (advancePaymentEnabledPreference: boolean) => void;
};

export const useAdvancePaymentEnabledPreference = (): UseAdvancePaymentEnabledPreferenceReturnFn => {
   const [advancePaymentEnabledPreference, setAdvancePaymentEnabledPreference] = useLocalStorage<boolean | undefined>(
      ADVANCE_PAYMENT_ENABLED_PREFERENCE_KEY,
      undefined
   );

   const handleSetAdvancePaymentEnabledPreference = useCallback(
      (advancePaymentEnabledPreference: boolean) => {
         setAdvancePaymentEnabledPreference(advancePaymentEnabledPreference);
      },
      [setAdvancePaymentEnabledPreference]
   );

   return {
      advancePaymentEnabledPreference: advancePaymentEnabledPreference,
      handleSetAdvancePaymentEnabledPreference: handleSetAdvancePaymentEnabledPreference,
   };
};
